export const environment = {
  production: true,
  application: {
    name: 'mxv-frontend',
    angular: 'Angular 19',
    bootstrap: 'Bootstrap 5.3.3',
    en: 'production',
  },
  apiUrl: 'https://mxv.app/api/website',
  endpoints: {
    api: 'https://mxv.app/api/website',
    login: 'https://mxv.app/api/website/auth/login',
    loginWithLink: 'https://mxv.app/api/website/auth/link-login',
    logout: 'https://mxv.app/api/website/auth/logout',
    signup: 'https://mxv.app/api/website/auth/signup',
    storage: 'https://myexclusivevillas.com/storage',
  },
  siteUrl: 'https://myexclusivevillas.com',
  iss: {
    login: 'https://mxv.app/api/website/auth/login',
    loginssl: 'https://mxv.app/api/website/auth/login',
    linklogin: 'https://mxv.app/api/website/auth/link-login',
    linkloginssl: 'https://mxv.app/api/website/auth/link-login',
    verify: 'https://mxv.app/api/website/auth/signup/verify-code',
    verify3: 'https://mxv.app/api/website/auth/signup/verify-code',
    verify2: 'https://mxv.app/api/website/auth/signup/verify-code',
    signup: 'https://mxv.app/api/website/auth/signup',
    // TODO: Implement OAuth routes in backend
    // google: 'https://mxv.app/api/website/auth/login/google/callback',
    // facebook: 'https://mxv.app/api/website/auth/login/facebook/callback',
  },
  cdnUrl: 'https://myexclusivevillas.com/storage',
};
